(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mailing-popup"]) return;
  try {
    
  (function() {
    var form = document.getElementById('newsletter--popup__form');
    if (!form) return;
    form.addEventListener('submit', function() {
      var consent = document.getElementById('PopupSmsConsent');
      var smsTag = document.getElementById('PopupSmsTag');
      if (consent && smsTag) {
        smsTag.disabled = !consent.checked;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
